// @flow

export type RouteWidth = {
    stops: Array<[number, number]>,
};

export const defaultRouteWidth: RouteWidth = {
    stops: [
        [10, 7],
        [15, 9],
        [19, 11],
    ],
};
